<template>
  <div class="AssociatedProducts">
    <el-dialog title="关联现有产品" :visible.sync="dialogVisible" width="73%" top="4vh">
      <div class="block">
        <div class="left">
          <el-tree :data="Treedata" node-key="id" :props="defaultProps" :highlight-current="highlight"
            default-expand-all :expand-on-click-node="false" @node-click="handleNodeClick">
          </el-tree>
        </div>
        <div class="right">
          <div class="summary_complete_bag">
            <el-form ref="form" :model="form" label-width="90px" :inline="true">
              <el-form-item label="销售类型">
                <el-select v-model="form.salesType" placeholder="请选择">
                  <el-option label="全部" :value="5"></el-option>
                  <el-option label="普通销售" :value="1"></el-option>
                  <el-option label="变参销售" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分类选项">
                <el-checkbox v-model="form.isNullCategory">无分类选项</el-checkbox>
              </el-form-item>
              <el-form-item label=" ">
                <el-input v-model.trim="form.input" style="width:340px" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="Search2">搜索</el-button>
                <el-button type="primary" @click="searchReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="summarylist" style="width: 100%" element-loading-text="拼命加载中" border
            :header-cell-style="iscenter" @selection-change="on_batch_select" row-key="id" default-expand-all
            :tree-props="{ children: 'variantAlias', hasChildren: 'hasChildren' }" :row-style="tableRowClassName">
            <el-table-column width="80" align="center">
              <template slot="header">
                <el-checkbox v-model="checked" @change="handleCheckAllChange"></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox v-if="scope.row.variantAlias" v-model="scope.row.checkedBox"
                  @change="handleChange(scope.row)"></el-checkbox>
                <el-checkbox v-else v-model="scope.row.checkedBox" @change="handleChange(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column width="150" label="SKU/SKU别名" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.variantSku">
                  <p>变体SKU：{{ scope.row.variantSku }}</p>
                </div>
                <div v-else>
                  <p>主SKU：{{ scope.row.productCode }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="140" label="关联图片" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.productImage" style="width: 100px; height: 100px"
                  :src="scope.row.productImage" fit="fill" :preview-src-list="scope.row.productImages"></el-image>
                <el-image v-if="scope.row.productSkuImages" style="width: 50px; height: 50px"
                  :src="scope.row.productSkuImages[0]" fit="fill" :preview-src-list="scope.row.productSkuImages">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column width="150" label="商品名称" align="center">
              <template slot-scope="scope">
                <div style="display:flex;justify-content: center;">
                  <div style="margin-right:20px">{{ scope.row.title }}</div>
                  <el-popover placement="right" width="420" trigger="hover">
                    <el-table :data="gridData" border>
                      <el-table-column align="center" property="date" label="SKU"></el-table-column>
                      <el-table-column align="center" property="name" label="3日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="7日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="15日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="30日销量"></el-table-column>
                    </el-table>
                    <div slot="reference">
                      <i class="el-icon-s-data" v-if="scope.row.title"></i>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="90" label="产品来源" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" width="200" trigger="hover">
                  <div v-for="(item, index) in scope.row.sourceUrl" :key="index">
                    <el-link type="primary" :href="item.url" target="_blank">{{ item.url }}</el-link>
                  </div>
                  <el-button slot="reference" type="text" style="border:none" v-if="scope.row.sourceUrl">访问</el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="销售类型" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.salesType">
                  <p v-if="scope.row.salesType == 1">普通销售</p>
                  <p v-else-if="scope.row.salesType == 2">变参销售</p>
                  <p v-else-if="scope.row.salesType == 3">捆绑销售</p>
                  <p v-else>组合销售</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="创建者" align="center" prop="creater" width="100">
            </el-table-column>
            <el-table-column label="归属者" align="center" width="130">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.itemsBelonger" :key="index">
                  {{ item.owner }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品状态" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 1" style="color: green">在售</p>
                <p v-else-if="scope.row.status == 2" style="color: red">停售</p>
                <p v-else-if="scope.row.status == 3" style="color: #0f59a4;">试卖</p>
                <p v-else-if="scope.row.status == 4" style="color: orange">部分停售</p>
                <p v-else-if="scope.row.status == 5">清仓</p>
                <p v-else>部分清仓</p>
              </template>
            </el-table-column>
            <el-table-column prop="stockNum" label="库存数量" align="center"></el-table-column>
            <el-table-column prop="createTime" width="100" label="创建时间" align="center"></el-table-column>
          </el-table>
          <div class="summary_pagenum_block">
            <div class="block">
              <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 50]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api'
export default {
  name: 'AssociatedProducts',
  data() {
    return {
      checked: false,
      highlight: true,
      currentPage: 1,
      size: 5,
      count: 1,
      piece: 0,
      batch_select: [],
      batch_select2: [],
      gridData: [],
      dialogVisible: false,
      Treedata: [],
      summarylist: [],
      defaultProps: {
        children: "children",
        label: "categoryName"
      },
      form: {
        salesType: 5,
        input: '',
        isNullCategory: false
      },
      iscenter: {
        textAlign: 'center',
        background: '#f8f8f8',
        color: '#232323',
      }
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.str.company_id
  },
  methods: {
    init() {
      this.dialogVisible = true
      this.getTreedata()
      this.getShopifyProduct()
      this.checked = false
    },
    tableRowClassName({ row }) {
      let styleRes = {"background": "#FAFAFA !important"}
      if (!row.variantAlias) return styleRes
    },
    save() {
      this.dialogVisible = false
      this.$emit('itemclick', this.batch_select, this.batch_select2)
    },
    handleCheckAllChange() {
      var arr = []
      var newarr = []
      this.summarylist.forEach(item => {
        if (item.variantAlias) {
          item.variantAlias.forEach(val => {
            if (this.checked) {
              arr.push(val)
              newarr.push({ combinationId: val.id })
              item.checkedBox = true
              val.checkedBox = true
            } else {
              item.checkedBox = false
              val.checkedBox = false
            }
          })
        } else {
          if (this.checked) {
            arr.push(item)
            newarr.push({ combinationId: item.variantAlia[0].id })
            item.checkedBox = true
          } else {
            item.checkedBox = false
          }
        }
      })
      this.piece = arr.length
      this.batch_select = newarr
      this.batch_select2 = arr
    },
    handleChange(val) {
      var newarr = [];
      var arr = [];
      this.summarylist.forEach(item => {
        if (item.variantAlias) {
          item.variantAlias.forEach(key => {
            if (val.variantAlias) {
              if (item.checkedBox == true) {
                key.checkedBox = true
                arr.push(key)
                newarr.push({ combinationId: key.id })
              } else {
                key.checkedBox = false
                this.checked = false
              }
            } else {
              if (key.checkedBox == true) {
                arr.push(key)
                newarr.push({ combinationId: key.id })
                const resule = item.variantAlias.every(val => val.checkedBox)
                if (resule) {
                  item.checkedBox = true
                }
              } else {
                item.checkedBox = false
                this.checked = false
              }
            }
          })
        } else {
          if (item.checkedBox == true) {
            arr.push(item)
            newarr.push({ combinationId: item.variantAlia[0].id })
          } else {
            item.checkedBox = false
            this.checked = false
          }
        }
      })
      const result = this.summarylist.every(item => item.checkedBox)
      if (result) {
        this.checked = true
      }
      this.piece = arr.length
      this.batch_select = newarr
      this.batch_select2 = arr
    },
    on_batch_select(val) {
      var newarr = []
      this.piece = val.length
      for (var i = 0; i < val.length; i++) {
        newarr.push({ combinationId: val[i].id })
      }
      this.batch_select = newarr
      this.batch_select2 = val
    },
    getShopifyProduct(categoryId) {
      const API = Baseurl + 'systemProduct/selectProductPage'
      const paramsData = {
        roleId: this.str.rid,
        page: this.currentPage,
        size: this.size,
        title: this.form.input,
        subSalesType: this.form.salesType,
        isNullCategory: this.form.isNullCategory,
        categoryId
      }
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code === 1) {
            res.data.data.records.map(item => {
              this.$set(item, 'variantAlia', JSON.parse(JSON.stringify(item.variantAlias)))
              if (item.salesType != 2) delete item.variantAlias
            })
            this.summarylist = res.data.data.records
            this.summarylist.forEach(val => {
              this.$set(val, 'checkedBox', false)
              if (val.variantAlias) {
                val.variantAlias.map(key => {
                  this.$set(key, 'checkedBox', false)
                  if ((typeof key.variantImages === "string") && key.variantImages) {
                    this.$set(key, 'productSkuImages', key.variantImages.split(","))
                  } else {
                    this.$set(key, 'productSkuImages', key.variantImages)
                  }
                })
              }
              const source = val.sourceUrl.split(',')
              val.productImages = val.productImages.split(',')
              if (val.productImages.length) {
                val.productImage = val.productImages[0]
              }
              val.sourceUrl = source.map((item) => ({
                url: item
              }))
            })
            this.count = res.data.data.total
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    handleSizeChange(val) {
      this.size = val
      this.getShopifyProduct()
    },
    getTreedata() {
      const API = Baseurl + 'shopifyCategory/find?companyId=' + this.str.company.id
      ajaxGet(API)
        .then((res) => {
          if (res.data.code === 1) {
            this.$set(this.Treedata, 0, { categoryName: '分类列表', children: [] })
            this.Treedata[0].children = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getShopifyProduct()
    },
    handleNodeClick(val) {
      this.highlight = true
      this.getShopifyProduct(val.id)
    },
    Search2() {
      this.getShopifyProduct()
    },
    searchReset() {
      this.highlight = false
      this.form.salesType = 5;
      this.form.isNullCategory = false
      this.form.input = ''
      this.getShopifyProduct()
      this.page = 5
      this.currentPage = 1
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #ccc !important;
}
/deep/ .el-tree-node__content:hover {
  background: #eee !important;
}
.block {
  display: flex;
  justify-content: space-between;
  .left {
    width: 15%;
    float: left;
    border: 1px solid #eee;
    padding: 10px 0;
    border-radius: 4px;
  }
  .right {
    width: 83%;
    .summary_complete_bag {
      overflow: hidden;
    }
    .summary_pagenum_block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
